module.exports = __webpack_public_path__ + "static/media/sign-in-background.23101dda.jpg";